// src/components/NotesCalendar.js
import React from "react";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameMonth,
  isSameDay,
} from "date-fns";
import { ArrowClockwise  } from "react-bootstrap-icons"; // ou ArrowClockwise
import { useTranslation } from 'react-i18next';
import "../css/Note.css";

const NotesCalendar = ({
  selectedDate,
  notes,
  onSelectDate,
  onMonthChange,
  colorCategories,
}) => {
  const { t } = useTranslation();
  
  if (!(selectedDate instanceof Date) || isNaN(selectedDate)) {
    console.warn("selectedDate n’est pas une date valide :", selectedDate);
    return null;
  }

  const monthStart = startOfMonth(selectedDate);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart, { weekStartsOn: 1 });
  const endDate = endOfWeek(monthEnd, { weekStartsOn: 1 });

  const rows = [];
  let days = [];
  let day = startDate;

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      const formattedDate = format(day, "dd/MM/yyyy");
      const cloneDay = day;
      const hasNotes = notes[formattedDate] || [];
      const uniqueCategories = Array.from(
        new Set(hasNotes.map((n) => n.categoryId))
      );
      const isToday = isSameDay(day, new Date());

      days.push(
        <div
          className={`calendar-cell 
            ${!isSameMonth(day, monthStart) ? "disabled" : ""} 
            ${isSameDay(day, selectedDate) ? "selected" : ""} 
            ${isToday ? "today" : ""}`}
          key={format(day, "yyyy-MM-dd")}
          onClick={() => {
            onSelectDate(cloneDay);            
          }}
          style={{
            display: "grid",
            gridTemplateRows: "1fr 1fr 1fr",
            gridTemplateColumns: "1fr 1fr 1fr",
            alignItems: "center",
            justifyItems: "center",
            height: "42px",
            width: "42px",
            backgroundColor: !isSameMonth(day, monthStart)
              ? "#f2f2f2"
              : isSameDay(day, selectedDate)
              ? "#EAE6FF"
              : "#FAFAFA",
            border: isSameDay(day, new Date())
              ? "2px solid #6F3F89"
              : "1px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.2s ease, border 0.2s ease",
          }}
        >
          {/* eslint-disable-next-line no-loop-func */}
          {Array.from({ length: 9 }).map((_, idx) => {
            const currentDay = day; // capture stable de la variable de boucle
            if (idx === 4) {
              return (
                <div
                  key="center"
                  style={{
                    gridRow: 2,
                    gridColumn: 2,
                    fontSize: "0.8em",
                    fontWeight: "700",
                    color: isSameMonth(currentDay, monthStart) ? "#333" : "#aaa",
                  }}
                >
                  {format(currentDay, "d")}
                </div>
              );
            }

            const catIndex = idx < 4 ? idx : idx - 1;
            const catId = colorCategories[catIndex]?.id;
            const hasNotesCat = uniqueCategories.includes(catId);
            const color = hasNotesCat
              ? colorCategories[catIndex].color
              : "transparent";

            return (
              <div
                key={idx}
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "4px",
                  backgroundColor: color,
                }}
              />
            );
          })}
        </div>
      );
      day = addDays(day, 1);
    }

    rows.push(
      <div className="calendar-row" key={`row-${format(day, "yyyy-MM-dd")}`}>
        {days}
      </div>
    );
    days = [];
  }

  return (
    <div className="calendar-overlay">
  {/* Header du mois */}
  <div className="calendar-header-top">
    <button onClick={() => onMonthChange(-1)}>←</button>
    
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <h3 style={{ margin: 0 }}>{format(selectedDate, "dd MMMM yyyy")}</h3>
        <button
          onClick={() => onSelectDate(new Date())}
          style={{
            border: "none",
            background: "none",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            padding: 0,
            color: "#fff",
          }}
          title="Aujourd'hui"
        >
          <ArrowClockwise size={18} />
        </button>
      </div>
      <button onClick={() => onMonthChange(1)}>→</button>
  </div>

  {/* Jours de la semaine */}
    <div className="calendar-header">
      <div>{t('note.calendar.lun')}</div>
      <div>{t('note.calendar.mar')}</div>
      <div>{t('note.calendar.mer')}</div>
      <div>{t('note.calendar.jeu')}</div>
      <div>{t('note.calendar.ven')}</div>
      <div>{t('note.calendar.sam')}</div>
      <div>{t('note.calendar.dim')}</div>
    </div>

    {/* Grille des jours */}
    {rows}

  </div>
  );
};

export default NotesCalendar;
